import { z } from 'zod';
import { ErrorResponseSchema } from '@/schemas/common/base';

/**
 * POST/DELETE /api/listings/[id]/feature-for-partner param schema
 * Features or unfeatures a listing for a partner (admin only)
 */
export const FeatureForPartnerParamSchema = z.object({
  id: z.string().refine(val => !isNaN(Number(val)), 'Invalid listing ID'),
});

/**
 * POST/DELETE /api/listings/[id]/feature-for-partner request body schema
 */
export const FeatureForPartnerRequestSchema = z.object({
  membershipType: z.coerce.number().positive('Invalid membership type'),
});

/**
 * POST/DELETE /api/listings/[id]/feature-for-partner response schema
 * Returns the new featured status and partner name
 */
export const FeatureForPartnerResponseSchema = z.discriminatedUnion('success', [
  z.object({
    success: z.literal(true),
    featured: z.boolean(),
    partner: z.string(),
    alreadyFeatured: z.boolean().optional(),
    notFeatured: z.boolean().optional(),
  }),
  ErrorResponseSchema.extend({
    alreadyFeatured: z.boolean().optional(),
    notFeatured: z.boolean().optional(),
    details: z.string().optional(),
  }),
]);

export type FeatureForPartnerParam = z.infer<typeof FeatureForPartnerParamSchema>;
export type FeatureForPartnerRequest = z.infer<typeof FeatureForPartnerRequestSchema>;
export type FeatureForPartnerResponse = z.infer<typeof FeatureForPartnerResponseSchema>;
